import * as React from "react";
import { SVGProps } from "react";
const SvgLeftArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.7} cx={25} cy={25} r={25} fill="#fff" />
    <path
      d="M22.222 33.334 13.89 25m0 0 8.333-8.333M13.89 25H36.11"
      stroke="#574BA3"
      strokeWidth={1.13}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgLeftArrow;
